module.exports = __webpack_public_path__ + "img/coin-off.e7581972.svg";